import { render, staticRenderFns } from "./CommissionTypeEditor.vue?vue&type=template&id=1426c37a&scoped=true"
import script from "./CommissionTypeEditor.vue?vue&type=script&lang=js"
export * from "./CommissionTypeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1426c37a",
  null
  
)

export default component.exports